import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RESPONSES_QUERY_KEYS } from 'components/responses/constants';
import { api } from 'controllers/network/apiClient';

export interface ClassificationOption {
  name: string;
  label: string;
}

export const CLASSIFICATIONS_BASE_URL = '/v2/responses/classification';
export const CLASSIFICATIONS_CATEGORIES_URL = `${CLASSIFICATIONS_BASE_URL}/categories`;

const getClassifications = async (): Promise<ClassificationOption[]> => {
  const response = await api.get(CLASSIFICATIONS_CATEGORIES_URL);
  return response.categories;
};

export const useClassifications = (): UseQueryResult<ClassificationOption[]> =>
  useQuery({
    queryKey: [RESPONSES_QUERY_KEYS.CLASSIFICATIONS],
    queryFn: getClassifications,
    staleTime: Infinity,
  });
